// extracted by mini-css-extract-plugin
export var actions = "_qe-4";
export var item = "_qe-1";
export var price = "_qe-3";
export var quantity = "_qe-2";
export var table = "_qe-0";